import { Fragment, useEffect, useReducer, useState } from "react"
import useIsMobile from "../../../../hook/useIsMobile"
import Skeleton from "react-loading-skeleton"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import InfoIcon from "../../../InfoIcon"
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons"
import ToggleButton from "../../../ToggleButton"
import useRole from "../../../../hook/useRole"
import useFetch from "../../../../hook/useFetch"
import { notificationActions } from "../../../../store/notification-slice"
import { useDispatch } from "react-redux"
import { useConfirmation } from "../../../AppModal"

export default function Order({ orders, user }) {
    const { isMobile } = useIsMobile()

    const [trorder, setTrOrder] = useState()
    const [searchParams] = useSearchParams()
    const selectedOrderId = searchParams.get('order')


    useEffect(() => {
        if (orders) {
            let items = []

            Object.keys(orders).forEach(key => {
                let item = orders[key]

                items.push(
                    <Item key={key} item={item} user={user} initiallyOpen={String(item.id) === selectedOrderId} />
                )
            })

            setTrOrder(items)
        }



    }, [orders, selectedOrderId])

    if (!trorder) {
        return <Skeleton count={50} />
    }

    return <div className={`right-col bg-white ${isMobile ? 'mt-3' : ''}`} >
        <div className="table-responsive">
        <table className="table table-striped table-bordered" >
            <thead>
                <tr>

                    <th>OrderID</th>
                    <th>Product</th>
                    <th>Details</th>
                </tr>
            </thead>
            <tbody>
                {trorder}
            </tbody>
        </table>
        </div>
    </div>

}


function Item({ item, user, initiallyOpen }) {

    const confirmAction = useConfirmation()

    const [showDetails, setShowDetails] = useState(initiallyOpen)

    const componentReducer = (state, action) => {
        switch (action.type) {
            case 'order.active':
                return { ...state, active: !state.active }
            case 'order.active.set':
                return { ...state, active: action.data }
            case 'order.start':
                return { ...state, start: action.data }
            case 'order.end':
                return { ...state, end: action.data }
            default:
                return state
        }
    }
    const [componentState, dispatchComponent] = useReducer(componentReducer, item)

    const { hasrole } = useRole('rsosuperuser')
    const { hasrole: hasAdminRole } = useRole('admin')
    const canRefund = hasrole || hasAdminRole

    const { update, del } = useFetch()

    let dispatch = useDispatch()

    let navigate = useNavigate()

    const isUnlimited = Number(item.product_validity_mode) === 0
    const orderStatus = item.expired ? 'Expired' : (componentState.active ? 'Active' : 'Inactive')
    const orderStatusClass = item.expired ? 'bg-danger' : (componentState.active ? 'bg-success' : 'bg-secondary')
    const [paymentStatus, setPaymentStatus] = useState(item.payment_status)
    const [refundRequestStatus, setRefundRequestStatus] = useState(item.refund_request_status)



    return <Fragment>
        <tr >
            <td>{item.order_id}</td>
            <td><Link to={`/admin/products/${item.product_id}`} >{item.ptitle}</Link></td>
            <td><InfoIcon className='btn btn-outline-secondary' title='details' icon={faCircleArrowDown} onClick={() => {
                setShowDetails(!showDetails)
            }} /></td>
        </tr>

        {showDetails &&

            <Fragment>

                <tr>
                    <th>Status</th>
                    <td colSpan={2}><span className={`badge ${orderStatusClass}`}>{orderStatus}</span></td>
                </tr>
                <tr>
                    <th>Payment</th>
                    <td colSpan={2}>
                        <span className={`badge ${paymentStatus === 'completed' ? 'bg-success' : (paymentStatus === 'refunded' ? 'bg-warning text-dark' : 'bg-secondary')}`}>
                            {paymentStatus || 'not recorded'}
                        </span>
                    </td>
                </tr>
                {refundRequestStatus && <tr>
                    <th>Refund request</th>
                    <td colSpan={2}>
                        <span className={`badge ${refundRequestStatus === 'pending' ? 'bg-warning text-dark' : 'bg-secondary'}`}>
                            {refundRequestStatus}
                        </span>
                        {item.refund_requested_at && <span className="ms-2">{item.refund_requested_at}</span>}
                    </td>
                </tr>}
                <tr>
                    <th>Activate</th>

                    <td colSpan={2} ><ToggleButton defaultChecked={componentState.active} onToggle={() => {
                        dispatchComponent({
                            type: 'order.active'
                        })
                    }} /></td>
                </tr>
                <tr>
                    <th>Start</th>
                    <td colSpan={2} ><input disabled={!hasrole} type='date' defaultValue={componentState.start} onInput={(e) => {
                        dispatchComponent({
                            type: 'order.start',
                            data: e.target.value
                        })
                    }} /></td>

                </tr>
                <tr>
                    <th>End</th>
                    <td colSpan={2}>{isUnlimited ? <span>Unlimited</span> : <input disabled={!hasrole} type='date' defaultValue={componentState.end} onInput={(e) => {
                        dispatchComponent({
                            type: 'order.end',
                            data: e.target.value
                        })
                    }} />}</td>
                </tr>

                <tr>
                    <td colSpan={3}><button className="btn btn-secondary" type="button" onClick={async () => {
                        if (await confirmAction('Die Bestellung wird geändert. Möchten Sie fortfahren?', 'Bestellung aktualisieren')) {
                            update(`/admin/order`, {
                                active: componentState.active ? 1 : 0,
                                start: componentState.start,
                                end: isUnlimited ? '' : componentState.end,
                                id: componentState.id,
                                order_id: componentState.order_id

                            }, null, () => {

                                dispatch(notificationActions.setNotification({
                                    message: `order updated`,
                                    status: true
                                }))


                                navigate('/admin/users', {
                                    state: {
                                        refetch: true
                                    }
                                })
                            })
                        }
                    }} >Update</button></td>
                </tr>

                <tr>
                    <td colSpan={3} >
                        <button type="button" disabled={!hasrole} className="btn btn-warning" onClick={async () => {
                            if (await confirmAction('Möchten Sie diese Bestellung wirklich löschen?', 'Löschen bestätigen')) {
                                del(`/admin/order`, { id: componentState.id }, (data) => {
                                    dispatch(notificationActions.setNotification({
                                        message: data,
                                        status: false
                                    }))
                                },
                                    () => {
                                        dispatch(notificationActions.setNotification({
                                            message: `order deleted`,
                                            status: true
                                        }))


                                        navigate(`/admin/users/${user.id}`, {
                                            state: {
                                                refetch: true
                                            }
                                        })
                                    })
                            }

                        }} >Delete</button>
                    </td>
                </tr>

                {canRefund && paymentStatus === 'completed' && <tr>
                    <td colSpan={3}>
                        <button type="button" className="btn btn-danger" onClick={async () => {
                            if (await confirmAction('Diese PayPal-Zahlung wird erstattet; zugehörige Bestellungen und Lizenzen werden deaktiviert.', 'Rückerstattung bestätigen')) {
                                update('/admin/payment/rollback', { order_id: componentState.id }, (error) => {
                                    dispatch(notificationActions.setNotification({ message: error, status: false }))
                                }, (payment) => {
                                    setPaymentStatus(payment.status)
                                    setRefundRequestStatus(payment.refund_request_status)
                                    dispatchComponent({ type: 'order.active.set', data: false })
                                    dispatch(notificationActions.setNotification({
                                        message: payment.status === 'refunded' ? 'Payment refunded' : 'Refund is pending',
                                        status: true
                                    }))
                                })
                            }
                        }}>{refundRequestStatus === 'pending' ? 'Approve refund request' : 'Refund payment'}</button>
                        {refundRequestStatus === 'pending' && <button type="button" className="btn btn-secondary ms-2" onClick={async () => {
                            if (await confirmAction('Möchten Sie diese Rückerstattungsanfrage ablehnen? Zahlung, Bestellung und Lizenzen bleiben aktiv.', 'Anfrage ablehnen')) {
                                update('/admin/payment/rollback-reject', { order_id: componentState.id }, (error) => {
                                    dispatch(notificationActions.setNotification({ message: error, status: false }))
                                }, (payment) => {
                                    setRefundRequestStatus(payment.refund_request_status)
                                    dispatch(notificationActions.setNotification({
                                        message: 'Refund request rejected. The order remains active.',
                                        status: true
                                    }))
                                })
                            }
                        }}>Reject request</button>}
                    </td>
                </tr>}

            </Fragment>


        }
    </Fragment>
}
